import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export enum ChartChannel {
  sms = 'sms',
  whatsapp = 'whatsapp',
  viber = 'viber',
}

interface DashboardState {
  chartChannel: ChartChannel;
}

const initialState: DashboardState = { chartChannel: ChartChannel.sms };

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    setChartChannel: (state, action: PayloadAction<ChartChannel>) => {
      state.chartChannel = action.payload;
    },
  },
});

export const { setChartChannel } = dashboardSlice.actions;

export default dashboardSlice.reducer;
